import { Context } from '@nuxt/types'
import { contentStripHTMLTags } from '~/utils/content'

export default function (context: Context) {
  const searchQueryParam = context.route.query.s
  if (searchQueryParam) {
    if (typeof searchQueryParam !== 'string') {
      return context.redirect('/')
    }

    const stripedSearchQueryParam = contentStripHTMLTags(searchQueryParam)

    if (searchQueryParam !== stripedSearchQueryParam) {
      return context.redirect(context.route.path, {
        ...context.route.query,
        s: stripedSearchQueryParam,
      })
    }
  }
}
